import { throwIfMissingEnvVar } from 'config/envVars/helpers';

export const SNAPENGAGE_ID = throwIfMissingEnvVar(
  'SNAPENGAGE_ID',
  process.env.SNAPENGAGE_ID
);

export const PLATGEN_SENTRY_DSN = throwIfMissingEnvVar(
  'PLATGEN_SENTRY_DSN',
  process.env.PLATGEN_SENTRY_DSN
);

export const PLATGEN_DATADOG_APPLICATION_ID =
  process.env.PLATGEN_DATADOG_APPLICATION_ID || '';

export const PLATGEN_DATADOG_CLIENT_TOKEN =
  process.env.PLATGEN_DATADOG_CLIENT_TOKEN || '';

export const PLATGEN_NHS_LINK = process.env.PLATGEN_NHS_LINK || '';

export const PLATGEN_SINGULAR_SDK_KEY =
  process.env.PLATGEN_SINGULAR_SDK_KEY || 'bighealth_8b9fd55c';
export const PLATGEN_SINGULAR_SDK_SECRET =
  process.env.PLATGEN_SINGULAR_SDK_SECRET || 'c65265155b6d1a8de24c00a5570aad38';
